import { useContext, useEffect, useState } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import ApiService from "../../../../services/api";
import "../css/news_content.css";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../services/auth";
import parse from "html-react-parser";
import moment from "moment";

const NewsContent = () => {
  const { isEnglish } = useContext(AuthContext);
  const [news, setNews] = useState({});
  const [Loading, setLoading] = useState(true);
  const fetchNewsCaterory = async () => {
    try {
      const newsList = await ApiService.getNews();
      setNews(newsList);
      setLoading(false);
    } catch (error) {
      setLoading(true);
    }
  };

  useEffect(() => {
    fetchNewsCaterory();
  }, []);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className=" padding_custom px-0 ">
      <h2 className="section-title text-center mt-5">NEWS</h2>
      <div className="border-custom mt-3 mb-4"></div>
      <Container fluid className="p-0">
        <Container>
          <Col className=" m-0">
            <Row className="m-0 pt-5 d-flex justify-content-center align-items-center">
              {news.map((card) => {
                return (
                  <Col
                    key={card.id}
                    xxl={3}
                    xl={4}
                    lg={6}
                    xs={12}
                    className="my-5  gx-3"
                  >
                    <Container
                      fluid
                      className="p-0 m-0  w-100 h-100 d-flex justify-content-center"
                    >
                      <div className="container_news text-decoration-none w-100 h-100 ">
                        <div className="m-0 p-0 h-100 w-100">
                          <Link to={"/news/" + card.slug}>
                            <img
                              src={card.image}
                              alt=""
                              className=" object-fit-cover w-100 h-100 img-news"
                            ></img>
                          </Link>

                          <h6 className="pt-3 text-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-calendar3 me-2"
                              viewBox="0 0 16 16"
                            >
                              <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                              <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                            </svg>
                            {moment(card.date).format("DD-MM-YYYY")}
                          </h6>
                          <h3 className="text-center section-title mt-4">
                            {isEnglish ? card.title_eng : card.title}
                          </h3>
                        </div>
                        <div className="w-100 text-center my-3">
                          <h5 className="text-start px-3">
                            {isEnglish
                              ? parse(
                                  card.description_eng.length > 150
                                    ? card.description_eng.slice(0, 150) + "..."
                                    : card.description_eng.slice(0, 150)
                                )
                              : parse(
                                  card.description.length > 150
                                    ? card.description.slice(0, 150) + "..."
                                    : card.description.slice(0, 150)
                                )}
                          </h5>
                          <div className="text-end px-3 py-3">
                            <Link
                              className="text-decoration-none site-link p-2"
                              to={"/news/" + card.slug}
                            >
                              {isEnglish ? "Read more" : "Leggi tutto"}
                            </Link>
                          </div>
                          <Badge className="bg-dark text-center p-2" pill>
                            {isEnglish
                              ? card.category.name_eng
                              : card.category.name}
                          </Badge>
                        </div>
                      </div>
                    </Container>
                  </Col>
                );
              })}
              {news.length === 0 && (
                <h2 className="text-center section-text">
                  {isEnglish
                    ? "There are currently no news available."
                    : "Al momento non è presente nessuna news"}
                </h2>
              )}
            </Row>
          </Col>
        </Container>
      </Container>
    </Container>
  );
};
export default NewsContent;
